import React from 'react'

const MiniFooter = () => (
  <div id="mini-footer">
    <div className="footer-social">
      <a
        href="https://www.facebook.com/Asda"
        className="social-link social-link-facebook "
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-facebook" />
      </a>
      <a
        href="https://twitter.com/asda/"
        className="social-link social-link-twitter"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-twitter" />
      </a>
      <a
        href="https://www.instagram.com/asda/"
        className="social-link social-link-instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-instagram" />
      </a>
      <a
        href="https://www.pinterest.com/asda/"
        className="social-link social-link-pintrest"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="icon-pintrest" />
      </a>
    </div>
    <div className="footer-logo-wapper">
      <div className="footer-logo" />
    </div>
    <div className="copy-right">
      <p>
        © ASDA
        {new Date().getFullYear()}
      </p>
    </div>
  </div>
)

export default MiniFooter



// WEBPACK FOOTER //
// ./components/footer/MiniFooter.js